import React, { useEffect, useRef } from 'react';
import { Box, FormLabel, Stack } from '@mui/material';
import { FONT_CSS_MAP } from '../TiptapEditor/Toolbar/data';

const parser = new DOMParser();

const HtmlPreview = ({ htmlValue, inset = false, showLabel = true, height }) => {
	const iframeRef = useRef();

	useEffect(() => {
		if (iframeRef.current) {
			const value = htmlValue ?? '';
			const doc =
				iframeRef.current.contentDocument || iframeRef.current.contentWindow.document; // style="font-family: Arial, sans-serif;" // class="ql-font-arial"
			doc.open();

			console.log('Html for preview before parse', value);
			const viewDoc = parser.parseFromString(value, 'text/html');

			const styleTags = Array.from(viewDoc.head.querySelectorAll('style'));

			const hasBodyFont = styleTags.find((style) =>
				/body\s*\{[^}]*font-family\s*:/.test(style.textContent ?? '')
			);

			if (!hasBodyFont) {
				const styleEl = doc.createElement('style');
				styleEl.textContent = `
			body {
				font-family: ${FONT_CSS_MAP.arial};
			}
		`.trim();
				viewDoc.head.appendChild(styleEl);
			}

			console.log(
				'Html for preview after adding default Arial font',
				viewDoc.documentElement.outerHTML
			);
			doc.write(viewDoc.documentElement.outerHTML);
			doc.close();
		}
	}, [htmlValue]);

	return (
		<Stack spacing={1} height={height ?? '1000px'}>
			{showLabel && <FormLabel>Preview</FormLabel>}
			<Box
				sx={(theme) => ({
					...(inset && {
						border: `1px solid ${theme.palette.divider}`,
						borderRadius: '4px',
						// height: '1000px',
						// overflow: 'hidden',
					}),
					height: '100%',
					overflow: 'hidden',
				})}
			>
				<iframe
					ref={iframeRef}
					title='Email Preview'
					style={{
						width: '100%',
						height: '100%',
						border: 'none',
					}}
				/>
			</Box>
		</Stack>
	);
};

export default HtmlPreview;
